import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrRight",
  "use": "icon-arrRight-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol class=\"styles-1dxk6ak\" viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrRight\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4857 12L7.83276 17.6529L9.24698 19.0671L16.3141 12L9.24698 4.93289L7.83276 6.34711L13.4857 12Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol